import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { TIMELINE } from "@/data/site";

const Timeline = () => {
  return (
    <section className="bg-beige py-24 md:py-32">
      <div className="container-x">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="eyebrow mb-4">Levensmomenten</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight">
            Van eerste hartslag tot laatste dans
          </h2>
          <p className="mt-6 text-neutral-600 leading-relaxed">
            <span className="font-script text-gold text-3xl">Jullie verhaal</span>
            <br />
            vastgelegd voor het leven.
          </p>
        </div>

        <div className="relative">
          {/* horizontal line for large screens */}
          <div className="hidden lg:block absolute top-8 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />

          <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-9 gap-y-10 gap-x-4">
            {TIMELINE.map((t, i) => {
              const Icon = Icons[t.icon] || Icons.Star;
              return (
                <motion.div
                  key={t.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: i * 0.05 }}
                  className="flex flex-col items-center text-center"
                >
                  <div className="relative w-16 h-16 rounded-full border border-gold/40 bg-white flex items-center justify-center mb-4">
                    <Icon size={22} className="text-gold" strokeWidth={1.5} />
                  </div>
                  <p className="font-serif text-lg leading-tight">{t.title}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Timeline;
